import { render, staticRenderFns } from "./app_user_bankcard.vue?vue&type=template&id=b8936036&scoped=true&"
import script from "./app_user_bankcard.vue?vue&type=script&lang=js&"
export * from "./app_user_bankcard.vue?vue&type=script&lang=js&"
import style0 from "./app_user_bankcard.vue?vue&type=style&index=0&id=b8936036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8936036",
  null
  
)

export default component.exports